import {
  type BreadcrumbItem,
  Breadcrumbs,
  type BreadcrumbColorVariant,
} from '@natu/ui/Breadcrumbs';
import { BreadcrumbsFromUrl } from '@natu/ui/Breadcrumbs/BreadcrumbsFromUrl';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import {
  type SBProps,
  type Spacing,
  type BlokItem,
  resolveStoryblokStyles,
  sbEditable,
  getLinkPropsFromStoryblok,
  type StoryblokLink,
} from '../../../../utils';

interface SBBreadcrumbsProps {
  colorVariant?: BreadcrumbColorVariant;
  items?: BlokItem[];
  mt?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mb?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

const getSbBreadcrumbItems = (items: BlokItem[]): BreadcrumbItem[] =>
  items.map(item => ({
    title: (item.title || '') as string,
    link: getLinkPropsFromStoryblok(item?.link as StoryblokLink),
  }));

export const SBBreadcrumbs = ({ blok }: SBProps<SBBreadcrumbsProps>) => {
  const {
    items,
    colorVariant = 'default',
    mb,
    mbTablet,
    mbDesktop,
    mt,
    mtTablet,
    mtDesktop,
  } = blok;

  const className = resolveStoryblokStyles({
    mt,
    mtTablet,
    mtDesktop,
    mb,
    mbTablet,
    mbDesktop,
  });

  if (isArrayWithLength(items)) {
    return (
      <Breadcrumbs
        className={className}
        colorVariant={colorVariant}
        items={getSbBreadcrumbItems(items)}
        {...sbEditable()}
      />
    );
  }

  return <BreadcrumbsFromUrl className={className} colorVariant={colorVariant} {...sbEditable()} />;
};
